
import { RequestDetailEdit } from '../../../models/requestDetailEdit';


export class MaterialsController implements ng.IController {
    static $inject = ['$mdMedia', '$mdDialog'];

    constructor(private _$mdMedia: angular.material.IMedia, private _$mdDialog: ng.material.IDialogService
        ) {
    }

    isFormRequestedFromAddNewRequest: boolean;
    requestDetailEdit: RequestDetailEdit;
    _isNewMaterial: boolean;
    _editIndex : number;

    $onInit() { }


    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    get isNewMaterial(): boolean {
        return this._isNewMaterial;
    }

    get editIndex(): number {
        return this._editIndex;
    }

    deleteMaterial(event: MouseEvent, index: number): void {
       
        this.requestDetailEdit.requestMaterial.requestMaterials[index].isDeleted = true;
        this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[index].requestMaterials.isDeleted = true;
        
        if ((this.requestDetailEdit.requestMaterial.requestMaterials[index].materialId === undefined ||
            this.requestDetailEdit.requestMaterial.requestMaterials[index].materialId === null) &&
            (this.requestDetailEdit.requestMaterial.requestMaterials[index].isDeleted)) {

            this.requestDetailEdit.requestMaterial.requestMaterials.splice(index, 1);
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.splice(index, 1);
        }

       
    }

  

    get isValid(): boolean {
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestMaterials  !== undefined &&
            this.requestDetailEdit.requestMaterial.requestMaterials.filter(o => !o.isDeleted).length > 0 &&
            this.requestDetailEdit.requestMaterial.requestMaterials.filter(o => !o.isDeleted).length <= 75) {
            return true;
        }
        return false;
    }

   

    set isValid(val: boolean) { }

    get showErrorMessageOnMaterialsInValidOnReceiverEditScreen() {
        if (!this.isFormRequestedFromAddNewRequest && !this.isValid) {
            return true;
        }
        return false;
    }

    get isAddMaterialAllowed(): boolean {
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestMaterials !== undefined &&
            this.requestDetailEdit.requestMaterial.requestMaterials.filter(o => !o.isDeleted).length > 75) {
            return false;
        }
        return true;
    }
    addMaterial(event: MouseEvent, index: number): void {
        this.addMaterialDialogShow(event, index);
    }


    private addMaterialDialogShow(event: MouseEvent, index: number) {

        if (index === -1) {
            this._isNewMaterial = true;
        } else {
            this._isNewMaterial = false;
            this._editIndex = index;
        }

        this._$mdDialog.show({
            template: `<md-dialog flex> <material-dialog layout-fill
                            request-detail-edit="vm.requestDetailEdit"
                            edit-index="vm.editIndex" is-new-material = "vm.isNewMaterial">
                            </material-dialog> </md-dialog>`,

            parent: angular.element(document.body),
            targetEvent: event,
            onComplete: () => {
                angular.element(document.querySelector('md-dialog')).addClass('min-size-personnel');
            },
            controller: () => { },
            locals: {
                requestDetailEdit: this.requestDetailEdit,
                editIndex: this.editIndex,
                isNewMaterial: this.isNewMaterial


            },
            bindToController: true,
            controllerAs: 'vm'

        });

    }

    

    private isPackagesAssignmentExistsInAssignedMaterials(requestDetailEdit : RequestDetailEdit) : boolean {

        if (requestDetailEdit !== undefined &&
            requestDetailEdit.requestMaterial !== undefined &&
            requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            
            for (var eachAssignedMaterialToPackage of requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage ) {
                if (eachAssignedMaterialToPackage !== undefined && eachAssignedMaterialToPackage !== null &&
                    (!eachAssignedMaterialToPackage.requestMaterials.isDeleted) &&
                    eachAssignedMaterialToPackage.assignedPc !== undefined &&
                    eachAssignedMaterialToPackage.assignedPc !== null && eachAssignedMaterialToPackage.assignedPc > 0) {
                    return true;
                }

            }

        }
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/materials/controllers/materialsController.ts
 **/